<template>
  <v-app-bar app dark dense clipped-left fixed>
    <v-app-bar-nav-icon
      class="hidden-lg-and-up"
      @click.native.stop="
        $store.commit('VUETIFY_DRAWER', !$store.state.user.drawer.isActive)
      "
    ></v-app-bar-nav-icon>
    <router-link link :to="{ name: 'home' }">
      <v-avatar class="mr-3" rounded size="28" >
        <img alt="synpse-logo" src="/favicon-32x32.png" />
      </v-avatar>
    </router-link>    

    <v-spacer></v-spacer>    

    <v-btn-toggle v-if="currentNamespaceID">
      <v-btn
        small
        router
        :to="{
          name: 'applications',
          params: {
            project: currentProjectID,
            namespace: currentNamespaceID,
          },
        }"
      >
        Applications
        <!-- <v-icon>mdi-format-align-left</v-icon> -->
      </v-btn>
      <v-btn
        small
        router
        :to="{
          name: 'secrets',
          params: {
            project: currentProjectID,
            namespace: currentNamespaceID,
          },
        }"
      >
        Secrets
        <!-- <v-icon>mdi-format-align-center</v-icon> -->
      </v-btn>
    </v-btn-toggle>

    <v-spacer></v-spacer>

    <v-menu
      class="items"
      bottom
      left
      offset-y
      origin="top right"
      transition="v-slide-y-transition"
      v-if="currentProjectID && selectedProject"
    >
      <template v-slot:activator="{ on: on }">
      <v-btn
        v-on="on"
        small
        text
        class="secondary--text mr-3"
        router
       
      >          
        <v-icon small class="mr-2" >unfold_more</v-icon>
        {{ selectedProject.name  }}        
      </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(membership, index) in projects"
          :key="index"
          router
          @click="selectProjectAndGo(membership)"
        >
          <v-list-item-title>{{ membership.project.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-btn
      v-if="authenticated && currentProjectID"
      small
      text
      class="secondary--text mr-3"
      :to="{
        name: 'projectDetails',
        params: {
          project: currentProjectID,
        },
      }"
      router
    >
      <v-icon class="mr-2" small >settings</v-icon>
      Settings
    </v-btn>

    <v-btn
      small 
      text
      class="secondary--text mr-3"
      :href="docs_href"
      target="_blank"
      rel="noopener"      
    >
      <v-icon class="mr-2" small >school</v-icon>
      Docs
    </v-btn>

    <v-menu
      v-if="authenticated"
      class="mp-4 ml-2"
      bottom
      offset-y
      origin="top right"
      transition="v-slide-y-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="secondary--text"
          small
          text
          v-bind="attrs"
          v-on="on"
        >
          <v-icon class="mr-2" small >terminal</v-icon>
          CLI
        </v-btn>
      </template>

      <v-list dense>
        <span>         
          <v-list-item>
            <install-cli-helper></install-cli-helper>            
          </v-list-item>

          <v-list-item>
            <configure-cli
              :project="selectedProject"
              :namespace="selectedNamespace"
              :namespaces="namespaces"
              :device="currentDeviceID"
            ></configure-cli>
          </v-list-item>
         
        </span>
      </v-list>
    </v-menu>

    <v-menu
      class="items"
      bottom
      left
      offset-y
      origin="top right"
      transition="v-slide-y-transition"
    >
      <template v-slot:activator="{ on: on }">
        <v-btn icon light v-on="on" class="white--text">
          <v-avatar v-if="avatarUrl" size="32">
            <img
              :src="avatarUrl"
              :alt="$store.state.user.user.name"
            >
          </v-avatar>
          <v-icon v-else>settings</v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <span v-for="(item, i) in dropdown_items" v-bind:key="i">
          <v-divider v-if="item.divider"></v-divider>
          <v-list-item
            v-else
            :key="i"
            :to="!item.target ? item.href : null"
            :href="item.target ? item.href : null"
            v-bind:router="!item.target"
            target="item.target"
          >
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item>
        </span>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import InstallCliHelper from './cli/InstallCli.vue';
import ConfigureCli from './cli/ConfigureCli.vue';

export default {
  components: {
    InstallCliHelper,
    ConfigureCli,
  },
  data() {
    return {
      tabs: null,
      context: 'app context',
      loaded: false,
      docs_href: 'https://docs.synpse.net/',
      // how_to_items: [
      //   { text: 'Managing servers', href: '#', target: '_blank' },
      //   { text: 'Deploying applications', href: '#', target: '_blank' },
      // ],
      unauthenticatedDropdownItems: [
        { icon: 'mdi-ssh', text: 'Templates', href: '/templates' },
        { divider: true },
        { text: 'Login', href: '/login' },
      ],
      authenticatedDropdownItems: [
        { icon: 'mdi-ssh', text: 'Profile', href: '/profile' },
        { icon: 'mdi-ssh', text: 'Billing', href: '/billing' },
        { icon: 'mdi-ssh', text: 'Templates', href: '/templates' },
        // { divider: true },
        // { text: 'Terms of service', href: 'https://synpse.net/tos', target: '_blank' },
        // { text: 'Privacy', href: 'https://synpse.net/privacy/', target: '_blank' },
        { divider: true },
        { text: 'Logout', href: '/logout' }
      ],
      cliHelperModal: false,
      cliConfigureModal: false,
    }
  },

  computed: {
    authenticated() {
      return this.$auth.check()
    },
    dropdown_items() {
      return this.authenticated
        ? this.authenticatedDropdownItems
        : this.unauthenticatedDropdownItems
    },
    selectedProject() {
      return this.$store.getters.getSelectedProject()
    },
    selectedNamespace() {
      return this.$store.getters.getNamespaceByID(this.currentNamespaceID)
    },
    currentProjectID() {
      return this.$route.params.project
    },
    currentDeviceID() {
      return this.$route.params.device
    },
    currentNamespaceID() {
      return this.$route.params.namespace
    },
    namespaces() {
      return this.$store.state.namespace.namespaces
    },
    projects() {
      return this.$store.state.project.memberships
    },
    avatarUrl() {
      if (!this.$store.state.user.user) {
        return ''
      }
      if (this.$store.state.user.user.providerName === 'github') {
        return `https://github.com/${this.$store.state.user.user.name}.png?size=36`
      }
      if (this.$store.state.user.user.providerName === 'google') {
        return this.$store.state.user.user?.info?.avatar_url
      }
      return ''
    },
  },

  mounted() {
    if (this.authenticated) {
      this.$store.dispatch('GetUser')
    }
  },  

  methods: {
    openCLIHelperModal() {
      this.cliHelperModal = true
    },
    closeCLIHelperModal() {
      this.cliHelperModal = false
    },
    selectProjectAndGo(selectedProject) {
      this.$store.dispatch('SelectProject', selectedProject.projectId)
      this.$store.dispatch('ResetDevicesList').then(() => {
        this.$router.push({
          name: 'devices',
          params: {
            project: selectedProject.projectId,
          },
        })
      })
    },
  }
}
</script>
